import React, { useCallback } from 'react';
import { EditIcon, IconButton, Typography } from '@commonsku/styles';
import { useDispatch } from 'react-redux';
import { useIdentity } from '../hooks';
import { createOrderPaymentCreditCardFeePopup } from '../actions/popup';
import { formatPercent } from '../utils';
import { EditProject } from '../types';
import { EditOrder } from '../types/order';

interface OrderCreditCardFeeEditHandleProps {
    project: EditProject;
    order: EditOrder;
    isUpfrontPayment?: boolean;
}

const OrderCreditCardFeeEditHandle = ({ project, order, isUpfrontPayment = false }: OrderCreditCardFeeEditHandleProps) => {
    const dispatch = useDispatch();
    const identity = useIdentity();

    const openCreditCardFeeSettings = useCallback((order, client) => {
        dispatch(createOrderPaymentCreditCardFeePopup(order, client));
    }, [dispatch]);

    const locked = 1 == order.locked;
    const percent = formatPercent(order.payment_cc_fee_percentage, 2);

    let creditCardFeeHandle = null;
    let blockStlye = {};
    let buttonStyles = {};
    if (isUpfrontPayment) {
        blockStlye = { fontWeight: 'normal', marginBottom: '0', display: 'block', float: 'right' };
        buttonStyles = { background: 'none', border: 'none' };
    }
    if (order.allow_cc_payment === 1) {
        creditCardFeeHandle = <>
            <Typography style={blockStlye}>
                {order.payment_cc_fee_enabled ?
                    `${percent} fee paid by ${project.account.company_name}` :
                    `Fee paid by ${identity.company_name}`}
                {!locked && <IconButton
                    style={buttonStyles}
                    variant='text'
                    Icon={EditIcon}
                    size='small'
                    onClick={e => { e.preventDefault(); openCreditCardFeeSettings(order, project.account); }}>Edit
                </IconButton>}
            </Typography>
        </>;
    }

    return creditCardFeeHandle;
};

export default OrderCreditCardFeeEditHandle;;